import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { provideRouter, RouterModule } from '@angular/router';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { EditorModule, TINYMCE_SCRIPT_SRC } from '@tinymce/tinymce-angular';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
// import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { AppRoutingModule, routes } from './app-routing.module';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { ThemeService } from './services/theme.service';
import { HeaderComponent } from './components/header/header.component';
import { SidebarComponent } from './components/sidebar/sidebar.component';
import { SubMenuTabsComponent } from './components/sub-menu-tabs/sub-menu-tabs.component';
import { LoginComponent } from './login/login.component';
import { StepperModule } from 'primeng/stepper';
import { MasterModule } from './pages/master/master.module';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { ProposalComponent } from './pages/master/proposal/proposal.component';
import { PrimeNgModule } from './shared/primeng.module';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { MessageService } from 'primeng/api';
// import { StapeModule } from './pages/stape-component/stape.module';

import { TransactionComponent } from './pages/transaction/transaction.component';
import { AIPComponent } from './pages/stape-component/aip/aip.component';
import { CommentingSeetComponent } from './pages/stape-component/commenting-seet/commenting-seet.component';
import { SotrComponent } from './pages/stape-component/sotr/sotr.component';
import { VendorComponent } from './pages/stape-component/vendor/vendor.component';
import { EOIComponent } from './pages/stape-component/eoi/eoi.component';
import { AONComponent } from './pages/stape-component/aon/aon.component';
import { RfpComponent } from './pages/stape-component/rfp/rfp.component';
import { PreBidComponent } from './pages/stape-component/pre-bid/pre-bid.component';
import { UploadDocComponent } from './pages/stape-component/upload-Eoi-doc/upload-doc.component';
import { TechnicalEveluationComponent } from './pages/stape-component/technical-eveluation/technical-eveluation.component';
import { BanchmarkComponent } from './pages/stape-component/banchmark/banchmark.component';
import { CommercialNegocatitionComponent } from './pages/stape-component/commercial-negocatition/commercial-negocatition.component';
import { ContractAwardComponent } from './pages/stape-component/contract-award/contract-award.component';
import { CommercialEvaluationComponent } from './pages/stape-component/financial-evaluation/commercial-evaluation.component';
import { PropogalDashboardComponent } from './pages/dashboard/propogal-dashboard/propogal-dashboard.component';
import { CommonModule, HashLocationStrategy, LocationStrategy } from '@angular/common';
import { NeedGenrationComponent } from './pages/stape-component/need-genration/need-genration.component';
import { RFiComponent } from './pages/stape-component/rfi/rfi.component';
import { DraftSocComponent } from './pages/stape-component/draft-soc/draft-soc.component';
import { VcnsApprovalComponent } from './pages/stape-component/vcns-approval/vcns-approval.component';
import { RfpDetailsComponent } from './pages/stape-component/rfp-details/rfp-details.component';
import { ReceiptMomComponent } from './pages/stape-component/receipt-mom/receipt-mom.component';
import { NominationOfQAAgencyComponent } from './pages/stape-component/nomination-of-qa-agency/nomination-of-qa-agency.component';
import { UserProfileComponent } from './shared/components/user-profile/user-profile.component';
import { NgxPrintModule } from 'ngx-print';
import { TreeTableModule } from 'primeng/treetable';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { Table, TableModule } from 'primeng/table';
import { SharedModule } from "./shared/shared.module";
import { UserDetailsComponent } from './shared/components/user-details/user-details.component';
import { UserMappingComponent } from './shared/components/user-mapping/user-mapping.component';
import { AccessPrivilegeComponent } from './shared/components/access-privilege/access-privilege.component';
import { PrivilegeComponent } from "./shared/components/privilege/privilege.component";
import { UserAccessPrivilegeComponent } from './shared/components/user-access-privilege/user-access-privilege.component';
import { IdexComponent } from './pages/idex/idex.component';
import { DiscComponent } from './pages/disc/disc.component';
import { InitiationOfProposalComponent } from './pages/stape-component/initiation-of-proposal/initiation-of-proposal.component';
import { ShortlistingVendorsComponent } from './pages/stape-component/shortlisting-vendors/shortlisting-vendors.component';
import { PreRfpMeetingComponent } from './pages/stape-component/pre-rfp-meeting/pre-rfp-meeting.component';
import { FreezeSOTRComponent } from './pages/stape-component/freeze-sotr/freeze-sotr.component';
import { ConstituteCommitteeComponent } from './pages/stape-component/constitute-committee/constitute-committee.component'; import { TransactionIdexComponent } from './pages/transaction-idex/transaction-idex.component';
import { IdexSqrComponent } from './pages/idex-sqr/idex-sqr.component';
import { IdexWinnersComponent } from './pages/idex-winners/idex-winners.component';
import { IdexPrototypeComponent } from './pages/idex-prototype/idex-prototype.component';
import { IdexUtrrComponent } from './pages/idex-utrr/idex-utrr.component';

import { TenderOpeningComponent } from './pages/stape-component/tender-opening/tender-opening.component';
import { TechnicalNegotiationsComponent } from './pages/stape-component/technical-negotiations/technical-negotiations.component';
import { MakeITechnicalNegotiationsComponent } from './pages/stape-component/make-i-technical-negotiations/make-i-technical-negotiations.component';
import { MakeIBenchmarkComponent } from './pages/stape-component/make-i-benchmark/make-i-benchmark.component';
import { FinalOfferComponent } from './pages/stape-component/final-offer/final-offer.component';
import { CompetentFinancialAuthorityComponent } from './pages/stape-component/competent-financial-authority/competent-financial-authority.component';
import { SanctionOrderComponent } from './pages/stape-component/sanction-order/sanction-order.component';
import { IdexCommercialRfpComponent } from './pages/idex-commercial-rfp/idex-commercial-rfp.component';
import { IdexFetComponent } from './pages/idex-fet/idex-fet.component';
import { IdexRfpSocComponent } from './pages/idex-rfp-soc/idex-rfp-soc.component';
import { EoiMasterComponent } from './pages/master/eoi-master/eoi-master.component';
import { MakeITransactionComponent } from './pages/make-i-transaction/make-i-transaction.component';
import { FeasibiltyStudyComponent } from './pages/feasibilty-study/feasibilty-study.component';
import { PsqrComponent } from './pages/psqr/psqr.component';
import { PddComponent } from './pages/pdd/pdd.component';
import { UploadDprComponent } from './pages/upload-dpr/upload-dpr.component';
import { DprSubmissionComponent } from './pages/dpr-submission/dpr-submission.component';
import { StaffEvaluationComponent } from './pages/staff-evaluation/staff-evaluation.component';
import { TrialDirectivesComponent } from './pages/trial-directives/trial-directives.component';
import { MakeIiTransactionComponent } from './pages/make-ii-transaction/make-ii-transaction.component';
import { EvaluationMasterComponent } from './pages/master/evaluation-master/evaluation-master.component';
import { PocMasterComponent } from './pages/master/poc-master/poc-master.component';
import { RevenuePocComponent } from './pages/revenue-poc/revenue-poc.component';
import { ClassComponent } from './pages/master/class/class.component';
import { ShipComponent } from './pages/master/ship/ship.component';
import { CommitteeComponent } from './pages/master/committee/committee.component';
import { IncubatorComponent } from './pages/master/incubator/incubator.component';
// import {CfiManagementComponent} from './components/cfi-management/cfi-management.component';
// import {CfiComponent} from './components/cfi-management/cfi/cfi.component'
import { VendorMasterComponent } from './pages/master/vendor-master/vendor-master.component';
import { StepMasterComponent } from './pages/master/step-master/step-master.component';
import { MakeIiiTransactionComponent } from './pages/make-iii-transaction/make-iii-transaction.component';
import { TdfTransactionComponent } from './pages/tdf-transaction/tdf-transaction.component';
import { CalendarComponent } from './pages/calendar/calendar.component';
import { IdexOcTransactionComponent } from './pages/idex-oc-transaction/idex-oc-transaction.component';
import { IdexAditiTransactionComponent } from './pages/idex-aditi-transaction/idex-aditi-transaction.component';
import { IdexFaujiTransactionComponent } from './pages/idex-fauji-transaction/idex-fauji-transaction.component';
import { CalendarModule } from 'primeng/calendar';
import { DraftTprComponent } from './pages/draft-tpr/draft-tpr.component';
import { PreliminaryDiscussionComponent } from './pages/preliminary-discussion/preliminary-discussion.component';
import { MasterOverviewComponent } from './pages/master/master-overview/master-overview.component';
import { SectionComponent } from './master/section/section.component';
import { StepPhaseComponent } from './master/step-phase/step-phase.component';
import { CardModule } from 'primeng/card';
import { SsctComponent } from './pages/ssct/ssct.component';
import { NominateDirectorateComponent } from './pages/nominate-directorate/nominate-directorate.component';
import { UploadDrawingsComponent } from './pages/upload-drawings/upload-drawings.component';
import { UploadQapAtpComponent } from './pages/upload-qap-atp/upload-qap-atp.component';
import { UploadFatsComponent } from './pages/upload-fats/upload-fats.component';
import { UserCertificateComponent } from './pages/user-certificate/user-certificate.component';
import { BulkProductionComponent } from './pages/bulk-production/bulk-production.component';
import { ProjectClosureComponent } from './pages/project-closure/project-closure.component';
import { PreliminaryDesignComponent } from './pages/preliminary-design/preliminary-design.component';
import { CriticalDesignComponent } from './pages/critical-design/critical-design.component';
import { ProductionSupplyComponent } from './pages/production-supply/production-supply.component';
import { TotComponent } from './pages/tot/tot.component';
import { PrototypeDeliveryComponent } from './pages/prototype-delivery/prototype-delivery.component';
import { StepStatusClassPipe } from './shared/step-status-class.pipe';
import { RoleDetailsComponent } from './shared/components/role-details/role-details.component';
import { HasPermissionPipe } from './shared/has-permission.pipe';
import { SearchResultsComponent } from './search-results/search-results.component';
import { AuthInterceptor } from './interceptors/auth.interceptor';
import { RopComponent } from './master/rop/rop.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { SchemeComponentComponent } from './scheme-component/scheme-component.component';
import { DoiDashboardComponent } from './pages/doi-dashboard/doi-dashboard.component';
import { IdexDashboardComponent } from './pages/idex-dashboard/idex-dashboard.component';
import { IdexSchemeListComponent } from './pages/idex-scheme-list/idex-scheme-list.component';
import { RevenueSchemeListComponent } from './pages/revenue-scheme-list/revenue-scheme-list.component';
import { LandingPageComponent } from './landing-page/landing-page.component';
import { AonSocComponent } from './pages/aon-soc/aon-soc.component';
import { IpValuationComponent } from './pages/ip-valuation/ip-valuation.component';
import { SharePdsPruComponent } from './pages/share-pds-pru/share-pds-pru.component';
import { UploadPdsPruComponent } from './pages/upload-pds-pru/upload-pds-pru.component';
import { MonitoringModuleComponent } from './pages/monitoring-module/monitoring-module.component';
import { ResizableColumnDirective } from './directives/resizable-column.directive';
import { IdexResponseComponent } from './pages/idex-response/idex-response.component';
import { IpValueComponent } from './pages/ip-value/ip-value.component';
import { IdexBidsComponent } from './pages/idex-bids/idex-bids.component';
import { SparkAgreementComponent } from './pages/spark-agreement/spark-agreement.component';
import { UploadWbsComponent } from './pages/upload-wbs/upload-wbs.component';
import { MapWbsPaymentComponent } from './pages/map-wbs-payment/map-wbs-payment.component';
import { MilestoneMasterComponent } from './pages/milestone-master/milestone-master.component';
import { ResizableRowDirective } from './directives/resizable-row.directive';
import { QRCodeComponent } from 'angularx-qrcode';
import { TdfSchemeListComponent } from './pages/tdf-scheme-list/tdf-scheme-list.component';
import { SeekProposalComponent } from './pages/seek-proposal/seek-proposal.component';
import { TdfDashboardComponent } from './pages/tdf-dashboard/tdf-dashboard.component';
import { Dropdown, DropdownModule } from 'primeng/dropdown';
import { OverlayPanel, OverlayPanelModule } from 'primeng/overlaypanel';
import { LaunchChallengeComponent } from './pages/launch-challenge/launch-challenge.component';
import { AutoComplete, AutoCompleteModule } from 'primeng/autocomplete';
import { RevenueDashbaordComponent } from './pages/revenue-dashbaord/revenue-dashbaord.component';
import { MakeDashboardComponent } from './pages/make-dashboard/make-dashboard.component';
import { MakeSchemeListComponent } from './pages/make-scheme-list/make-scheme-list.component';
import { RevenueVendorsComponent } from './pages/revenue-vendors/revenue-vendors.component';
import { RevenueBidComponent } from './pages/revenue-bid/revenue-bid.component';
import { MakeIBidComponent } from './pages/make-i-bid/make-i-bid.component';
import { RevenueEvaluationComponent } from './pages/revenue-evaluation/revenue-evaluation.component';
import { UploadChallengesComponent } from './pages/upload-challenges/upload-challenges.component';
import { ConcurrenceRfiComponent } from './pages/concurrence-rfi/concurrence-rfi.component';
import { FileManagementRouteComponent } from './pages/file-management-route/file-management-route.component';
import { NominationsComponent } from './pages/nominations/nominations.component';
import { StepsModule } from 'primeng/steps';
import { ButtonModule } from 'primeng/button';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { PILComponent } from './pages/master/pil/pil.component';
import { TestTransactionComponent } from './pages/test-transaction/test-transaction.component';
import { TabViewModule } from 'primeng/tabview';
import { UploadModule } from './modal/upload/upload.module';
import { AwardOfContractComponent } from './pages/award-of-contract/award-of-contract.component';
import { FirmResponseSubmissionComponent } from './pages/firm-response-submission/firm-response-submission.component';
import { DrdoAipComponent } from './pages/drdo-aip/drdo-aip.component';
import { NotificationComponent } from './components/notification/notification.component';
import { IndusXTransactionComponent } from './pages/indus-x-transaction/indus-x-transaction.component';
import { PrimeTransactionComponent } from './pages/prime-transaction/prime-transaction.component';
import { VenderSpecficDocumentComponent } from './components/vender-specfic-document/vender-specfic-document.component';
import { NeedfromComponent } from './components/needfrom/needfrom.component';
import { FirmResponseEvaluationComponent } from './pages/firm-response-evaluation/firm-response-evaluation.component';
import { PreparationOfPsqrFrommPddComponent } from './pages/preparation-of-psqr-fromm-pdd/preparation-of-psqr-fromm-pdd.component';
import { PsqrToSqrComponent } from './pages/psqr-to-sqr/psqr-to-sqr.component';
import { ConstituteContractNegotiationCommitteeComponent } from './pages/constitute-contract-negotiation-committee/constitute-contract-negotiation-committee.component';
import { TransHeaderSteperComponent } from './components/trans-header-steper/trans-header-steper.component';
import { IdexFromComponent } from './pages/idex-scheme-list/idex-from/idex-from.component';
import { UploadHatSatComponent } from './pages/stape-component/upload-hat-sat/upload-hat-sat.component';
import { MilestoneComponent } from './pages/idex-aditi-transaction/milestone/milestone.component';
import { OcProposalUploadComponent } from './pages/idex-scheme-list/oc-proposal-upload/oc-proposal-upload.component';
import { OcProposalDocumentUploadComponent } from './components/oc-proposal-upload/oc-proposal-upload.component';
import { OcShortlistingComponent } from './pages/idex-scheme-list/oc-shortlisting/oc-shortlisting.component';
import { AppComponent } from './app.component';
import { DmpComponent } from './components/dmp/dmp.component';
import { SummaryMetricsComponent } from './components/dashboard-widgets/summary-metrics/summary-metrics.component';
import { SubSchemeOverviewComponent } from './components/dashboard-widgets/sub-scheme-overview/sub-scheme-overview.component';
import { SchemeStatusBreakdownComponent } from './components/dashboard-widgets/scheme-status-breakdown/scheme-status-breakdown.component';
import { GrantSummaryComponent } from './components/dashboard-widgets/grant-summary/grant-summary.component';
import { StageCardsComponent } from './components/dashboard-widgets/stage-cards/stage-cards.component';
import { LaunchVersionCategorizationComponent } from './components/dashboard-widgets/launch-version-categorization/launch-version-categorization.component';
import { MilestoneTrackingTableComponent } from './components/dashboard-widgets/milestone-tracking-table/milestone-tracking-table.component';
import { ProjectFiltersComponent } from './components/dashboard-widgets/project-filters/project-filters.component';
import { NonContractedRejectedComponent } from './components/dashboard-widgets/non-contracted-rejected/non-contracted-rejected.component';
import { CdkVirtualScrollableElement } from "@angular/cdk/scrolling";
import { SchemeWiseRoutePopupComponent } from './components/scheme-wise-route-popup/scheme-wise-route-popup.component';
import { ReportComponent } from './components/report/report.component';
import { TicketManagementComponent } from './pages/ticket-managemnt/ticket-management/ticket-management.component';
import { CfiTransactionComponent } from './pages/master/cfi/cfi.transaction';
import { TdfFromComponent } from './pages/tdf-scheme-list/tdf-from';
import { SotrRfpComplienceMatrixComponent } from "./pages/sotr-rfp-complience-matrix/sotr-rfp-complience-matrix.component";
import { FirmCapacityAssessmentComponent } from './pages/stape-component/firm-capacity-assessment/firm-capacity-assessment.component';
import { UploadCommentsFromExternalAgenciesComponent } from './pages/stape-component/upload-comments-from-external-agencies/upload-comments-from-external-agencies.component';
import { IdexRfpComponent } from './pages/idex-rfp/idex-rfp.component';
import { ReviewConnectComponent } from './pages/review-connect/review-connect.component';
import { EvaluationOfEoiComponent } from './pages/evaluation-of-eoi/evaluation-of-eoi.component';
import { ShortlistingOfDasComponent } from './pages/shortlisting-of-das/shortlisting-of-das.component';
import { EventHistoryInterceptor } from './interceptors/event-history.interceptor';
import { LegacyDataComponent } from './pages/legacy-data/legacy-data.component';
import { ChatboxComponent } from './chatbox/chatbox.component';
import { DialogModule } from '@angular/cdk/dialog';
import { InputTextModule } from 'primeng/inputtext';


@NgModule({
  declarations: [
    PropogalDashboardComponent,
    AppComponent,
    DashboardComponent,
    TransactionComponent,
    AIPComponent,
    SotrComponent,
    VendorComponent,
    NeedGenrationComponent,
    RFiComponent,
    DraftSocComponent,
    VcnsApprovalComponent,
    RfpDetailsComponent,
    ReceiptMomComponent,
    EOIComponent,
    AONComponent,
    RfpComponent,
    PreBidComponent,
    UploadDocComponent,
    TechnicalEveluationComponent,
    BanchmarkComponent,
    CommercialNegocatitionComponent,
    ContractAwardComponent,
    CommercialEvaluationComponent,
    NominationOfQAAgencyComponent,
    UserProfileComponent,
    UserDetailsComponent,
    UserMappingComponent,
    AccessPrivilegeComponent,
    PrivilegeComponent,
    UserAccessPrivilegeComponent,
    IdexComponent,
    DiscComponent,
    TransactionIdexComponent,
    InitiationOfProposalComponent,
    ShortlistingVendorsComponent,
    PreRfpMeetingComponent,
    FreezeSOTRComponent,
    ConstituteCommitteeComponent,
    IdexSqrComponent,
    IdexWinnersComponent,
    IdexPrototypeComponent,
    IdexUtrrComponent,
    TenderOpeningComponent,
    TechnicalNegotiationsComponent,
    MakeITechnicalNegotiationsComponent,
    MakeIBenchmarkComponent,
    FinalOfferComponent,
    CompetentFinancialAuthorityComponent,
    SanctionOrderComponent,
    IdexCommercialRfpComponent,
    IdexFetComponent,
    IdexRfpSocComponent,
    EoiMasterComponent,
    MakeITransactionComponent,
    FeasibiltyStudyComponent,
    PsqrComponent,
    PddComponent,
    UploadDprComponent,
    DprSubmissionComponent,
    StaffEvaluationComponent,
    TrialDirectivesComponent,
    MakeIiTransactionComponent,
    EvaluationMasterComponent,
    PocMasterComponent,
    RevenuePocComponent,
    ClassComponent,
    ShipComponent,
    CommitteeComponent,
    IncubatorComponent,

    PILComponent,
    VendorMasterComponent,
    StepMasterComponent,
    RopComponent,
    MakeIiiTransactionComponent,
    TdfTransactionComponent,
    CalendarComponent,
    IdexOcTransactionComponent,
    IdexAditiTransactionComponent,
    IdexFaujiTransactionComponent,
    DraftTprComponent,
    PreliminaryDiscussionComponent,
    MasterOverviewComponent,
    SectionComponent,
    StepPhaseComponent,
    SsctComponent,
    NominateDirectorateComponent,
    UploadDrawingsComponent,
    UploadQapAtpComponent,
    UploadFatsComponent,
    UserCertificateComponent,
    BulkProductionComponent,
    ProjectClosureComponent,
    PreliminaryDesignComponent,
    CriticalDesignComponent,
    ProductionSupplyComponent,
    TotComponent,
    PrototypeDeliveryComponent,
    RoleDetailsComponent,
    SearchResultsComponent,
    SchemeComponentComponent,
    DoiDashboardComponent,
    IdexDashboardComponent,
    IdexSchemeListComponent,
    RevenueSchemeListComponent,
    AonSocComponent,
    IpValuationComponent,
    SharePdsPruComponent,
    UploadPdsPruComponent,
    UploadWbsComponent,
    SparkAgreementComponent,
    SeekProposalComponent,
    TdfSchemeListComponent,
    TdfDashboardComponent,
    MonitoringModuleComponent,
    MilestoneMasterComponent,
    MapWbsPaymentComponent,
    IpValuationComponent,
    IpValueComponent,
    IdexResponseComponent,
    IdexDashboardComponent,
    IdexBidsComponent,
    LaunchChallengeComponent,
    RevenueDashbaordComponent,
    MakeDashboardComponent,
    MakeSchemeListComponent,
    RevenueVendorsComponent,
    RevenueBidComponent,
    MakeIBidComponent,
    RevenueEvaluationComponent,
    UploadChallengesComponent,
    ResizableColumnDirective,
    LandingPageComponent,
    ConcurrenceRfiComponent,
    FileManagementRouteComponent,
    NominationsComponent,
    TestTransactionComponent,
    AwardOfContractComponent,
    FirmResponseSubmissionComponent,
    DrdoAipComponent,
    NotificationComponent,

    IndusXTransactionComponent,
    PrimeTransactionComponent,
    FirmResponseEvaluationComponent,
    PreparationOfPsqrFrommPddComponent,
    PsqrToSqrComponent,
    ConstituteContractNegotiationCommitteeComponent,
    UploadHatSatComponent,
    MilestoneComponent,
    SummaryMetricsComponent,
    SubSchemeOverviewComponent,
    SchemeStatusBreakdownComponent,
    GrantSummaryComponent,
    LaunchVersionCategorizationComponent,
    MilestoneTrackingTableComponent,
    ProjectFiltersComponent,
    NonContractedRejectedComponent,
    FirmCapacityAssessmentComponent,
    UploadCommentsFromExternalAgenciesComponent,
    IdexRfpComponent,
    ReviewConnectComponent,
    EvaluationOfEoiComponent,
    ShortlistingVendorsComponent,
    ShortlistingOfDasComponent,
    EOIComponent,



    LandingPageComponent,
    ConcurrenceRfiComponent,
    FileManagementRouteComponent,
    NominationsComponent,
    TestTransactionComponent,
    AwardOfContractComponent,
    FirmResponseSubmissionComponent,
    DrdoAipComponent,
    NotificationComponent,

    IndusXTransactionComponent,
    PrimeTransactionComponent,
    FirmResponseEvaluationComponent,
    PreparationOfPsqrFrommPddComponent,
    PsqrToSqrComponent,
    ConstituteContractNegotiationCommitteeComponent,
    UploadHatSatComponent,
    MilestoneComponent,
    SummaryMetricsComponent,
    SubSchemeOverviewComponent,
    SchemeStatusBreakdownComponent,
    GrantSummaryComponent,
    LaunchVersionCategorizationComponent,
    MilestoneTrackingTableComponent,
    ProjectFiltersComponent,
    NonContractedRejectedComponent,
    FirmCapacityAssessmentComponent,
    UploadCommentsFromExternalAgenciesComponent,
    EvaluationOfEoiComponent,
    ShortlistingOfDasComponent,
    LegacyDataComponent,
    ChatboxComponent
    



  ],
  imports: [
    BrowserModule,
    EditorModule,
    NgxPrintModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    AppRoutingModule,
    CommonModule,
    HttpClientModule,
    FormsModule,
    StepperModule,
    PrimeNgModule,
    TabViewModule,
    MasterModule,
    DropdownModule,
    HeaderComponent,
    SidebarComponent,
    SubMenuTabsComponent,
    LoginComponent,
    TreeTableModule,
    ToggleButtonModule,
    SharedModule,
    CalendarModule,
    StepStatusClassPipe,
    HasPermissionPipe,
    CommentingSeetComponent,
    DragDropModule,
    UploadModule,
    // LandingPageComponent,
    TableModule,
    QRCodeComponent,
    OverlayPanelModule,
    AutoCompleteModule,
    // PrimeNG
    StepsModule,
    CardModule,
    ButtonModule,
    InputTextareaModule,
    VenderSpecficDocumentComponent,
    NeedfromComponent,
    TransHeaderSteperComponent,
    IdexFromComponent,
    OcProposalUploadComponent,
    OcProposalDocumentUploadComponent,
    OcShortlistingComponent,
    DmpComponent,
    CdkVirtualScrollableElement,
    SchemeWiseRoutePopupComponent,
    ReportComponent,
    StageCardsComponent,
    CfiTransactionComponent,
    TdfFromComponent,
    SotrRfpComplienceMatrixComponent,
    DialogModule,
    InputTextModule,
    
    
    
  ],
  exports: [
    AIPComponent,
    SotrComponent,
    VendorComponent,
    StepStatusClassPipe,
    HasPermissionPipe,
    VenderSpecficDocumentComponent,
    TransHeaderSteperComponent,
    IdexFromComponent,
    OcProposalUploadComponent,
    OcProposalDocumentUploadComponent,
    OcShortlistingComponent,
    SchemeWiseRoutePopupComponent,
    ReportComponent,
    StageCardsComponent,
    CfiTransactionComponent,
    TdfFromComponent,
  ],
  providers: [

    { provide: LocationStrategy, useClass: HashLocationStrategy },
    { provide: TINYMCE_SCRIPT_SRC, useValue: 'tinymce/tinymce.min.js' },
    provideRouter(routes),
    provideAnimationsAsync(),
    MessageService,
    { provide: HTTP_INTERCEPTORS, useClass: EventHistoryInterceptor, multi: true },


  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
